import React from "react";

import './Loader.scss'
export const Loading = (props) => {
	return (
		<div className="StyledLoading">
		<div className="progress-css"></div>
		</div>
		// 	{/* <div className="progress-container"> */}
		// 		<div className="Progress">
		// 			<div className="progress-bar"></div>
		// 		</div>
		// 	{/* </div> */}
		// </div>
	)
}
export default Loading